/*
 * @Author: huanglin.like@qq.com
 * @LastEditTime: 2024-04-19 10:15:35
 */
import request from '@/utils/service'

export function orderListApi(data) {
  return request({
    url: '/chargePieOrder/list',
    method: 'get',
    params: data
  })
}

export function listApi(data) {
  console.log('params :>> ', data)
  return request({
    url: '/business/list',
    method: 'get',
    params: data
  })
}

// 结束订单（不关设备）
export function endOrderApi(data) {
  return request({
    url: '/chargePieOrder/adminCloseOrder',
    method: 'post',
    data
  })
}

// 关闭订单（订单和设备都关）
export function closeOrderApi(data) {
  return request({
    url: '/chargePieOrder/closeOrder',
    method: 'post',
    data
  })
}

// 更新卡单设备状态
export function resetDevice(devSn, devPort) {
  return request({
    url: `/chargePieOrder/resetDevice/${devSn}/${devPort}`,
    method: 'get'
  })
}

export function rechargeListApi(data) {
  return request({
    url: '/rechargeOrder/list',
    method: 'get',
    params: data
  })
}

export function chargeBackOrder(data) {
  return request({
    url: '/chargePieOrder/orderRefundApply',
    method: 'post',
    data
  })
}

export function exportOrder(data) {
  return request({
    url: '/chargePieOrder/exportExcel',
    method: 'get',
    params: data
  })
}

export function userWithdraw(data) {
  return request({
    url: '/userWithdraw/list',
    method: 'get',
    params: data
  })
}


export function orderFeeStandardDetailApi(code) {
  return request({
    url: `/chargePieOrder/chargePlanDetail/${code}`,
    method: 'get'
  })
}

export function orderDivvyListApi(code) {
  return request({
    url: `/chargePieOrder/chargePlanDivideList/${code}`,
    method: 'get'
  })
}

// 虚拟充值订单
export function virtualRechargeOrderList(data) {
  return request({
    url: '/virtualRechargeOrder/list',
    method: 'post',
    params: data
  })
}


// 超时占用订单
export function timeoutOccupancyOrder(data) {
  return request({
    url: '/timeoutOccupancyOrder/list',
    method: 'post',
    params: data
  })
}

// 超时占用订单-详情
export function timeoutOccupancyDetail(data) {
  return request({
    url: '/timeoutOccupancyOrder/detail',
    method: 'post',
    params: data
  })
}

// 超时占用订单-解除占用
export function releaseOccupancyApi(data) {
  return request({
    url: `/timeoutOccupancyOrder/releaseOccupancy/${data.refChargePieOrder}`,
    method: 'get'
  })
}

// 超时占用订单-退款
export function refundTimeoutOrder(data) {
  return request({
    url: '/timeoutOccupancyOrder/refundApply',
    method: 'post',
    data
  })
}
